<template>
  <div>

    <v-container px-0 fill-height ms-auto class="enquiryForm-Page overflow-x-hidden">
      <v-row> 
        <v-col>
          <v-stepper v-if="!completedForm" v-model="step" vertical>

            <v-banner two-line tile elevation="0" color="WarningBanner" v-if="$let('LoanEnquiryFormTopText') != ''">
              <v-avatar slot="icon" size="40" class="rounded-circle">
                <v-icon icon="icon" color="WarningBanner-darken-1">mdi-exclamation</v-icon>
              </v-avatar>
              <v-sheet color="WarningBanner WarningBanner-darken-1--text" v-html="$let('LoanEnquiryFormTopText')"></v-sheet >
            </v-banner>

            <v-stepper-step color="stepper" :complete="step > 1" step="1" id="Step1Header">{{ $let('PersonalDetailsSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="1" >
              <v-sheet color="white" class="custom-shadow pa-10">
                <PersonalDetails
                  :rules="validationRules"
                  @continueClick="_stepperContinue">
                </PersonalDetails>
              </v-sheet>
            </v-stepper-content>
    
            <v-stepper-step color="stepper" :complete="step > 2" step="2" id="Step2Header">{{ $let('HouseholdDetailsSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="2">
              <v-sheet color="white" class="custom-shadow pa-10">
                <HouseholdDetails
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </HouseholdDetails>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 3" step="3" id="Step3Header">{{ $let('EmploymentSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="3">
              <v-sheet color="white" class="custom-shadow pa-10">
                <EmploymentDetails
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </EmploymentDetails>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 4" step="4" id="Step4Header">{{ $let('FinancialIncomeSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="4">
              <v-sheet color="white" class="custom-shadow py-10">
                <FinancialDetails
                  :type="constants.inOutType_Income"
                  v-if="elsInUse.IncomeList"
                  :required="elsRequired.IncomeList"
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </FinancialDetails>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 5" step="5" id="Step5Header">{{ $let('FinancialExpenditureSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="5">
              <v-sheet color="white" class="custom-shadow py-10">
                <FinancialDetails
                  :type="constants.inOutType_Outgoing"
                  v-if="elsInUse.OutgoingList"
                  :required="elsRequired.OutgoingList"
                  :minLenght="loanEnquiryMinExpenditureLength"
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </FinancialDetails>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 6" step="6" id="Step6Header">{{ $let('DrawdownSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="6">
              <v-sheet color="white" class="custom-shadow pa-10">
                <Drawdown 
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </Drawdown>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 7" step="7" id="Step7Header">{{ $let('LoanRepaymentSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="7">
              <v-sheet color="white" class="custom-shadow pa-10">
                <Repayments 
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </Repayments>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 8" step="8" id="Step8Header">{{ $let('MarketingConsentSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="8">
              <v-sheet color="white" class="custom-shadow pa-10">
                <MarketingConsent 
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </MarketingConsent>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 9" step="9" id="Step9Header">{{ $let('OtherPreferencesSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="9">
              <v-sheet color="white" class="custom-shadow pa-10">
                <OtherPreferences 
                  :rules="validationRules"
                  @continueClick="_stepperContinue"
                  @backClick="_stepperBack">
                </OtherPreferences>
              </v-sheet>
            </v-stepper-content>

            <v-stepper-step color="stepper" :complete="step > 10" step="10" id="Step10Header">{{ $let('DeclarationsSectionTitle') }}</v-stepper-step>
            <v-stepper-content step="10">
              <v-sheet color="white" class="custom-shadow pa-10">
                <Declarations 
                  :rules="validationRules"
                  @saveClick="_stepperSave"
                  @backClick="_stepperBack">
                </Declarations>

                <v-banner two-line tile elevation="0" color="ErrorBanner" :value="showError">
                    <v-avatar slot="icon" size="40">
                      <v-icon  icon="icon" color="ErrorBanner-darken-1">mdi-close</v-icon>
                    </v-avatar>
                    <v-sheet color="ErrorBanner ErrorBanner-darken-1--text"><div v-html="alertText"></div></v-sheet>
                </v-banner>

              </v-sheet>
            </v-stepper-content>        

          </v-stepper>
        </v-col>
      </v-row>

    </v-container>

    <v-container v-if="completedForm" pa-0 fill-height ms-auto class="pop-container">  
      <v-row no-gutters>
        <v-col>
          
          <!-- saveResultText -->
          <v-sheet color="white" class="custom-shadow pa-10 overflow-hidden">
            <div color="text--text" v-html="saveResultText"></div>
            <div color="text--text" v-html="saveResultTextDocsToUpload"></div>
          </v-sheet>

          <BaseButton v-if="continueToDocPack"
            @click="_continueToDocPack"
            :label="$let('ContinueButtonLabel')">
          </BaseButton>

        </v-col>  
      </v-row>
    </v-container>

    <Confirm
      :show="showConfirmAbandon"
      :message="$let('ConfirmAbandonSession')"
      :title="$let('ConfirmationTitleDefault')"
      :yesText="$let('ConfirmationYesLabelDefault')"
      :noText="$let('ConfirmationNoLabelDefault')"
      @yesClick="_abandon"
      @noClick="_cancelConfirm">
    </Confirm>

    <Confirm
      :show="showConfirmSave"
      :message="$let('SaveLoanEnquiryConfirmationText')"
      :title="$let('ConfirmationTitleDefault')"
      :yesText="$let('ConfirmationYesLabelDefault')"
      :noText="$let('ConfirmationNoLabelDefault')"
      @yesClick="_saveLoanEnquiry"
      @noClick="_cancelConfirm">
    </Confirm>

    <Confirm
      :show="showConfirmRedirect"
      :message="confirmMessage"
      :title="$let('AlertTitleDefault')"
      :okText="$let('ConfirmationOkLabelDefault')"
      @okClick="_redirectToStart">
    </Confirm>    

    <LoadingOverlay
      :show="inAction">
    </LoadingOverlay>

  </div>
</template>

<script>

  import { mapGetters, mapActions } from "vuex";
  import PersonalDetails from "../components/personal-details.vue";
  import HouseholdDetails from "../components/household-details.vue";
  import EmploymentDetails from "../components/employment-details.vue";
  import FinancialDetails from "../components/financial-details.vue";
  import Drawdown from "../components/drawdown.vue";
  import Repayments from "../components/repayments.vue";
  import MarketingConsent from "../components/marketing-consent.vue";
  import OtherPreferences from "../components/other-preferences.vue";
  import Declarations from "../components/declarations.vue";
  import BaseButton from '@/shared/components/base-button.vue'
  import LoadingOverlay from '@/shared/components/loading-overlay.vue'
  
  import Confirm from "@/shared/components/confirm.vue";
  import validators from '@/shared/utils/validators.js';
  import router from '../router/index.js';
  import routerNames from '../router/router-names.js';
  import opmGeneric from '../utils/generic.js';
  import constants from '../constants/generic.js';
  import generic from '@/shared/utils/generic.js';
  import paramKeys from '../constants/param-keys.js'

  export default {
    name: "EnquiryForm",
    components: {
      Confirm,
      BaseButton,
      LoadingOverlay,
      PersonalDetails,
      HouseholdDetails,
      EmploymentDetails,
      FinancialDetails, 
      Drawdown, 
      Repayments, 
      MarketingConsent,
      OtherPreferences, 
      Declarations, 
    },
    data: () => ({
      constants,
      step: 1,
      showConfirmAbandon: false,
      showConfirmSave: false,
      completedForm: false,
      continueToDocPack: false,
      validationRules: {},
      abandonTo: null,
      dirty: false,
      saveResultText: undefined,
      saveResultTextDocsToUpload: undefined,
      showError: false,
      alertText: undefined,
      inAction: undefined,
      loanEnquiryMinExpenditureLength: 0,
      showConfirmRedirect: false,
      confirmMessage: "",
    }),

    beforeRouteLeave (to, from, next) {
      if (to.name === routerNames.Error || to.name === routerNames.DocPack) next();
      if (this.step > 1) {
        this.step--;
        next(false);
      }
      else {
        if (this.completedForm) router.push({ name: routerNames.Home }); // after save the "History.Back" action will redirect to home
        else {
          if (!this.dirty || this.abandonTo) next();
          else {
            this.abandonTo = to;
            this.showConfirmAbandon = true;
            next(false);
          }
        }
      }
    },

    created() {
      if (!this.$store.state.loanEnquiryData.enquiryFormAvailable) router.push({ name: routerNames.Home });
      opmGeneric.setElementsConfig(this, this.elementsConfig);

      // Validators with locale texts
      const validatorTexts = {
        reqFld: this.$let('RequiredFieldEmptyMessage'), 
        invEMail: this.$let('InvalidEMail'), 
        invNIN: this.$let('InvalidNINumber'), 
        invEirCode: this.$let('InvalidEirCode'),
        invPostCode: this.$let('InvalidPostCode'), 
        invPhoneNumber: this.$let('InvalidPhoneNumber'),
        invValue: this.$let('InvalidValue'),
        invChars: this.$let('InvalidCharsUsed'), 
        invSortCode: this.$let('InvalidSortCode')
      };
      this.validationRules = validators.validationRules(validatorTexts);
    },
    mounted() {
      this.loanEnquiryMinExpenditureLength = parseInt(generic.paramValue(this.$store, paramKeys.LoanAppExpenditureMinItemsConfirmation));
    },
    methods: {
      ...mapActions(["updateLocalLoanEnquiryData", "saveLoanEnquiry"]),

      _stepperBack() {
        if (this.inAction) return;
        // No validation on back button
        this.stepperStep(--this.step);
      },
      
      _stepperContinue(model, form) {
        let valid = true;
        if (form) valid = form.validate();
        if (valid) {
          this.updateLocalLoanEnquiryData(model); // Update state with current step model
          this.dirty = true;
          this.stepperStep(++this.step);
        }
      },

      _stepperSave(model, form) {
        let valid = true;
        if (form) valid = form.validate();
        if (valid) {
          model = Object.assign(model, window._inputs.inputModule); // On save assign module inputs to model
          this.updateLocalLoanEnquiryData(model); // Update state with current step model
          this.showConfirmSave = true;
        }
      },

      _abandon () {
        router.push(this.abandonTo);
      },

      _cancelConfirm () {
        this.showConfirmAbandon = false;
        this.showConfirmSave = false;
        this.abandonTo = null;
      },

      _redirectToStart() {
        window.location.href =
          window._inputs.inputGlobal.startUrl ?
            window._inputs.inputGlobal.startUrl :
            generic.paramValue(this.$store, paramKeys.ExpiredTokenRedirectUrl);
      },

      async _saveLoanEnquiry () {
        this.showConfirmSave = false;
        this.showError = false;
        this.inAction = true;
        const resp = await this.saveLoanEnquiry();
        this.inAction = false;

        if (resp.ReturnedErrorCode === constants.LOAN_ENQUIRY_SUCCESS) this.completeForm(this.$let('SaveLoanEnquirySavedSuccess'), true, resp.DocumentPackComplete);
        else {
          if (resp.ReturnedErrorCode === constants.PBCodes[412]) {
            const _text = this.$let('PBReturnCode_'.concat(resp.ReturnedErrorCode));
            this.confirmMessage = _text;
            this.showConfirmRedirect = true;
          }
          else {
            this.alertText = this.$let('PBReturnCode_'.concat(resp.ReturnedErrorCode));
            if (this.alertText === '') this.completeForm(this.$let('SaveLoanEnquiryErrorOnSaved'), false);
            else this.showError = true;
          }
        }
      },

      _continueToDocPack() {
        router.push({ name: routerNames.DocPack});
      },

      stepperStep(stepTo) {
        setTimeout(() => { window.scroll({left: 0, top: parseInt(document.getElementById('Step'.concat(stepTo, 'Header')).offsetTop), behavior: 'smooth'}); }, 520);
        this.showError = false;
      },

      completeForm(msg, success, docPackComplete) {
        if (success) window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        this.saveResultText = msg;
        if (success && !docPackComplete) this.saveResultTextDocsToUpload = this.$let('SaveLoanEnquirySavedSuccessDocToUpload');
        this.completedForm = success;
        this.continueToDocPack = !docPackComplete;
      }
    },
    computed: {
      ...mapGetters(["elementsConfig"]),
    }
  };


</script>

<style lang="scss">
  
  @import '@/shared/design/common.scss';
  @import '../design/styles.scss';

  .marginTop {
    margin-top: 30px !important;
  }

</style>